
const baseURL = "https://backend-ecom-sp72.onrender.com/api/v1";
export default baseURL;
